import subscribeSaga from './subscribeSaga';
import { reduxModuleLoaded } from './actions';
export function getModule() {
    return {
        id: 'tierCreator',
        sagas: [subscribeSaga],
        initialActions: [reduxModuleLoaded()],
        retained: false,
    };
}
//# sourceMappingURL=module.js.map